module.exports = __webpack_public_path__ + "img/sentra21.6c1468c5.png";